/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Download } from '@mui/icons-material';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  CardContent,
  Typography,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from '@mui/material';
import { EmptyTable } from 'components/EmptyTable';
import React, { useEffect, useState } from 'react';

// Tipo de evento
const eventTypeMap = {
  DIP: 'dip',
  SWELL: 'swell',
  RVC: 'rvc',
  INTERRUPCIÓN: 'intrp',
};

// Función para formatear la fecha YYYY-mm-dd hh:mm:ss
function formatDate(date) {
  const d = new Date(date);

  const day = d.getDate();
  const year = d.getFullYear();

  // Obtener el nombre del mes en español con Intl
  const month = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(d);

  return `${day} ${month} ${year}`;
}

function formatTime(date) {
  const d = new Date(date);

  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');
  const seconds = String(d.getUTCSeconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}

const typeTimeFilter = {
  MAS_RECIENTE: 'MAS_RECIENTE',
  MAS_ANTIGUO: 'MAS_ANTIGUO',
};

const Events = ({
  handleEventsModal,
  openEvents,
  events,
  isBlocking,
  handleDownloadEvents,
}) => {
  // Evento activo
  const [activeEvent, setActiveEvent] = useState('TODOS');
  // Tipo de eventos
  const eventTypes = ['TODOS', 'DIP', 'SWELL', 'RVC', 'INTERRUPCIÓN'];
  // Eventos filtrados
  const [filteredEvents, setFilteredEvents] = useState([]);
  // Filtro mas reciente o mas antiguo
  const [filteredTime, setFilteredTime] = useState();

  useEffect(() => {
    let filtered = [...events];

    // Filtro por tipo
    if (activeEvent !== 'TODOS') {
      const tipoFiltro =
        activeEvent === 'INTERRUPCIÓN' ? 'intrp' : activeEvent.toLowerCase();
      filtered = filtered.filter((event) => event.tipo === tipoFiltro);
    }

    // Orden por fecha
    if (filteredTime === typeTimeFilter.MAS_RECIENTE) {
      filtered.sort(
        (a, b) => new Date(b.evento.startTime) - new Date(a.evento.startTime)
      );
    } else if (filteredTime === typeTimeFilter.MAS_ANTIGUO) {
      filtered.sort(
        (a, b) => new Date(a.evento.startTime) - new Date(b.evento.startTime)
      );
    }

    setFilteredEvents(filtered);
  }, [events, activeEvent, filteredTime]);

  return (
    <Dialog
      open={openEvents}
      onClose={handleEventsModal}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle
        id="form-dialog-title"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Chip
          label="Eventos Registrados"
          sx={{
            backgroundColor: '#730065',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '16px',
          }}
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDownloadEvents}
          sx={{ margin: 2 }}
          loading={isBlocking}
          aria-label="download"
          loadingPosition="start"
          startIcon={<Download />}
        >
          {isBlocking ? 'Descargando...' : 'Descargar Reporte'}
        </Button>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="row"
          gap={1}
          justifyContent="space-between"
          alignItems="center"
          my={2}
        >
          <Box
            display="flex"
            flexDirection="row"
            gap={1}
            alignItems="center"
            flexWrap="wrap"
          >
            {eventTypes.map((text, index) => {
              const tipoReal = eventTypeMap[text]; // puede ser undefined si es 'TODOS'
              const count =
                text === 'TODOS'
                  ? events.length
                  : events.filter((event) => event.tipo === tipoReal).length;

              return (
                <Button
                  key={index}
                  variant={activeEvent === text ? 'contained' : 'outlined'}
                  color="secondary"
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    justifyContent: 'center',
                  }}
                  onClick={() => setActiveEvent(text)}
                >
                  {text}
                  <Typography fontSize="12px" color="#ff0000">
                    ({count})
                  </Typography>
                </Button>
              );
            })}
          </Box>
          <FormControl sx={{ minWidth: 120, width: 150 }}>
            <InputLabel id="demo-simple-select-label">Ordenar Por:</InputLabel>
            {/* Ordena por fecha, el mas reciente o el mas antiguo*/}
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filteredTime}
              label="Ordenar Por:"
              onChange={(e) => setFilteredTime(e.target.value)}
            >
              <MenuItem value="">
                <em>Default</em>
              </MenuItem>
              <MenuItem value={typeTimeFilter.MAS_RECIENTE}>
                Mas Reciente
              </MenuItem>
              <MenuItem value={typeTimeFilter.MAS_ANTIGUO}>
                Mas Antiguo
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
          {filteredEvents?.map((event, index) => (
            <Card
              key={index}
              sx={{
                margin: 1,
                padding: 2,
                backgroundColor: '#fcfcfc',
                boxShadow: 3,
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                  gap={2}
                  sx={{ marginBottom: 2 }}
                >
                  <Chip
                    label={event.tipo}
                    variant="outlined"
                    sx={{
                      backgroundColor: '#ff000040',
                      textTransform: 'uppercase !important',
                      border: '2px solid #ff0000',
                      fontSize: '12px',
                      fontWeight: 'bold !important',
                      color: '#ff0000',
                      marginBottom: 1,
                    }}
                  />
                </Box>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', md: 'row' }}
                  flexWrap="nowrap"
                  gap={1}
                  justifyContent="space-between"
                  alignItems="start"
                >
                  <Box
                    width={{ xs: '100%', md: '40%' }}
                    display="flex"
                    flexDirection="column"
                    gap={1}
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body1"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <b>Fecha de Incio de Evento: </b>
                      {formatDate(event?.evento?.startTime)}
                    </Typography>
                    <Typography
                      variant="body1"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <strong>Incio de Evento:</strong>{' '}
                      {formatTime(event?.evento?.startTime)}
                    </Typography>
                    <Typography
                      variant="body1"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <strong>Fin de Evento:</strong>{' '}
                      {formatTime(event?.evento?.endTime)}
                    </Typography>
                  </Box>
                  <Box
                    width={{ xs: '100%', md: '30%' }}
                    gap={1}
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body1"
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <strong>Duración:</strong>{' '}
                      {event?.evento?.durationInCycles} ciclos
                    </Typography>
                    {event.tipo === 'rvc' && (
                      <>
                        <Typography
                          variant="body1"
                          display="flex"
                          flexDirection="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <strong>deltaUmax:</strong> {event?.evento?.deltaUmax}
                        </Typography>
                        <Typography
                          variant="body1"
                          display="flex"
                          flexDirection="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <strong>deltaUss:</strong> {event?.evento?.deltaUss}
                        </Typography>
                      </>
                    )}
                    {event.tipo === 'swell' && (
                      <Typography
                        variant="body1"
                        display="flex"
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <strong>Maxíma Magnitud Swell:</strong>{' '}
                        {event?.evento?.maxMag}
                      </Typography>
                    )}
                    {event.tipo === 'dip' && (
                      <Typography
                        variant="body1"
                        display="flex"
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <strong>Maxíma Magnitud Dip:</strong>{' '}
                        {event?.evento?.minMag}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ))}
          {filteredEvents.length === 0 && (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <EmptyTable text="No hay Eventos Registrados" />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '90%',
          margin: '0 auto',
        }}
      >
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="caption">
            Los eventos de calidad de energía se basa en la siguiente norma:
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontStyle: 'italic',
            }}
          >
            *Norma IEC 61000-4-30 Clase S*
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            handleEventsModal();
            setFilteredTime();
            setActiveEvent('TODOS');
          }} // This should close the modal
          sx={{ margin: 2 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Events;
// Note: The dummyEvents array is used for demonstration purposes. In a real application, you would fetch this data from an API or state management system.
// The handleEventsModal function should be defined in the parent component to control the modal's open/close state.
// The openEvents prop should also be managed in the parent component to control the visibility of the modal.
